<div class="popup-overlay" *ngIf="visible" (click)="close()">
  <div class="popup-content parcel-edit-popup" (click)="$event.stopPropagation()">
    
    <div class="popup-header">
      <h3 class="popup-title">
        <i class="fas fa-edit me-2"></i>
        Modifica Collo
      </h3>
      <button type="button" class="btn-close" (click)="close()" aria-label="Close">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="popup-body">
      <form [formGroup]="parcelForm" novalidate>
        
        <!-- Informazioni Collo -->
        <div class="mb-4">
          <h5 class="section-title">
            <i class="fas fa-box me-2"></i>
            Informazioni Collo
          </h5>
          <div class="row g-3">
            <div class="col-md-6">
              <label class="form-label fw-bold">Codice Collo</label>
              <div class="form-control-plaintext border rounded p-2 bg-light">
                <i class="fas fa-barcode me-2 text-muted"></i>
                {{ parcel?.parcelCode || '-' }}
              </div>
            </div>
            <div class="col-md-6">
              <label class="form-label fw-bold">Codice Bolla</label>
              <div class="form-control-plaintext border rounded p-2 bg-light">
                <i class="fas fa-file-alt me-2 text-muted"></i>
                {{ parcel?.parcelWaybillCode || '-' }}
              </div>
            </div>
          </div>
        </div>

        <!-- Peso e Volume -->
        <div class="mb-4">
          <h5 class="section-title">
            <i class="fas fa-weight me-2"></i>
            Peso e Volume
          </h5>
          <div class="row g-3">
            <div class="col-md-6">
              <label class="form-label fw-bold">
                Peso (kg) - Opzionale
              </label>
              <div class="position-relative">
                <input type="number" 
                       class="form-control ps-5" 
                       formControlName="parcelWeight" 
                       step="0.01" 
                       placeholder="Peso (opzionale)"
                       [class.is-invalid]="parcelForm.get('parcelWeight')?.invalid && parcelForm.get('parcelWeight')?.touched">
                <i class="fas fa-weight-hanging position-absolute top-50 start-0 translate-middle-y ms-3 text-muted" style="pointer-events: none;"></i>
                <span class="input-unit">kg</span>
              </div>
              <div *ngIf="parcelForm.get('parcelWeight')?.invalid && parcelForm.get('parcelWeight')?.touched" 
                   class="invalid-feedback d-block">
                {{ getParcelFieldError('parcelWeight') }}
              </div>
            </div>

            <div class="col-md-6">
              <label class="form-label fw-bold">
                Volume (m³)
              </label>
              <div class="position-relative">
                <input type="number" 
                       class="form-control ps-5 pe-5" 
                       formControlName="parcelVolume" 
                       step="0.0001" 
                       min="0" 
                       placeholder="0.0000"
                       [class.is-invalid]="parcelForm.get('parcelVolume')?.invalid && parcelForm.get('parcelVolume')?.touched">
                <i class="fas fa-cube position-absolute top-50 start-0 translate-middle-y ms-3 text-muted" style="pointer-events: none;"></i>
                <span class="input-unit">m³</span>
              </div>
              <div *ngIf="parcelForm.get('parcelVolume')?.invalid && parcelForm.get('parcelVolume')?.touched" 
                   class="invalid-feedback d-block">
                {{ getParcelFieldError('parcelVolume') }}
              </div>
            </div>
          </div>
        </div>

        <!-- Dimensioni -->
        <div class="mb-4">
          <h5 class="section-title">
            <i class="fas fa-ruler-combined me-2"></i>
            Dimensioni
          </h5>
          <div class="row g-3">
            <div class="col-md-4">
              <label class="form-label fw-bold">
                Lunghezza (cm)
              </label>
              <div class="position-relative">
                <input type="number" 
                       class="form-control ps-5 pe-5" 
                       formControlName="parcelLength" 
                       step="0.1" 
                       min="0" 
                       placeholder="0.0"
                       [class.is-invalid]="parcelForm.get('parcelLength')?.invalid && parcelForm.get('parcelLength')?.touched">
                <i class="fas fa-arrows-alt-h position-absolute top-50 start-0 translate-middle-y ms-3 text-muted" style="pointer-events: none;"></i>
                <span class="input-unit">cm</span>
              </div>
              <div *ngIf="parcelForm.get('parcelLength')?.invalid && parcelForm.get('parcelLength')?.touched" 
                   class="invalid-feedback d-block">
                {{ getParcelFieldError('parcelLength') }}
              </div>
            </div>

            <div class="col-md-4">
              <label class="form-label fw-bold">
                Larghezza (cm)
              </label>
              <div class="position-relative">
                <input type="number" 
                       class="form-control ps-5 pe-5" 
                       formControlName="parcelWidth" 
                       step="0.1" 
                       min="0" 
                       placeholder="0.0"
                       [class.is-invalid]="parcelForm.get('parcelWidth')?.invalid && parcelForm.get('parcelWidth')?.touched">
                <i class="fas fa-arrows-alt-v position-absolute top-50 start-0 translate-middle-y ms-3 text-muted" style="pointer-events: none;"></i>
                <span class="input-unit">cm</span>
              </div>
              <div *ngIf="parcelForm.get('parcelWidth')?.invalid && parcelForm.get('parcelWidth')?.touched" 
                   class="invalid-feedback d-block">
                {{ getParcelFieldError('parcelWidth') }}
              </div>
            </div>

            <div class="col-md-4">
              <label class="form-label fw-bold">
                Altezza (cm)
              </label>
              <div class="position-relative">
                <input type="number" 
                       class="form-control ps-5 pe-5" 
                       formControlName="parcelHeight" 
                       step="0.1" 
                       min="0" 
                       placeholder="0.0"
                       [class.is-invalid]="parcelForm.get('parcelHeight')?.invalid && parcelForm.get('parcelHeight')?.touched">
                <i class="fas fa-arrows-alt position-absolute top-50 start-0 translate-middle-y ms-3 text-muted" style="pointer-events: none;"></i>
                <span class="input-unit">cm</span>
              </div>
              <div *ngIf="parcelForm.get('parcelHeight')?.invalid && parcelForm.get('parcelHeight')?.touched" 
                   class="invalid-feedback d-block">
                {{ getParcelFieldError('parcelHeight') }}
              </div>
            </div>
          </div>
        </div>

        <!-- Volume Calculation Alert -->
        <div *ngIf="showVolumeAlert" class="alert alert-info d-flex align-items-center justify-content-between" role="alert">
          <div class="d-flex align-items-center">
            <i class="fas fa-calculator me-3 text-info"></i>
            <div>
              <strong>Volume calcolato dalle dimensioni:</strong>
              <span class="ms-2 fw-bold">{{ calculatedVolume.toFixed(4) }} m³</span>
              <div class="small text-muted mt-1">
                Vuoi utilizzare questo valore per il campo volume?
              </div>
            </div>
          </div>
          <div class="d-flex gap-2">
            <button type="button" 
                    class="btn btn-sm btn-info" 
                    (click)="applyCalculatedVolume()">
              <i class="fas fa-check me-1"></i>
              Usa questo valore
            </button>
          </div>
        </div>

      </form>
    </div>

    <div class="popup-footer">
      <div class="d-flex justify-content-end gap-2">
        <button type="button" class="btn btn-secondary" (click)="close()">
          <i class="fas fa-times me-2"></i>
          Annulla
        </button>
        <button type="button" 
                class="btn btn-primary" 
                (click)="onSubmit()"
                [disabled]="parcelForm.invalid || isSubmitting">
          <i class="fas fa-save me-2"></i>
          Salva
          <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm ms-2" role="status"></span>
        </button>
      </div>
    </div>

  </div>
</div>
